import React, {ComponentPropsWithoutRef} from 'react'
import {MembersAuth} from '../../Auth/MembersAuth'
import {MembersPageTemplate} from '../Molecules/BaseMembersPages/MembersPageTemplate'

type MembersPageAuthTemplateProps = ComponentPropsWithoutRef<typeof MembersPageTemplate>

export const MembersPageAuthTemplate: React.VFC<MembersPageAuthTemplateProps> = (
  props
) => {
  const {children, ...rest} = props

  return (
    <MembersPageTemplate {...rest}>
      <MembersAuth>
        {children}
      </MembersAuth>
    </MembersPageTemplate>
  )
}
